import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useInstallationContext } from '../../../../context/installation';
import { AllActionsQuery, AllActionsQueryVariables } from '../../../../data-access/gql-types/graphql';
import { ALL_ACTIONS } from '../../../../data-access/queries/actions';
import { useActionsStore } from '../../store/actions';
import { useCacheStore } from '../../store/cache';
import { UserActionsCollectionSegmentPick } from '../../types/cache';

export const useFetchActions = () => {
  const { selectedInstallationId, skipLavvaFetch } = useInstallationContext();
  const { setActions, shouldRefetchActions, resetRefetchActions } = useActionsStore((s) => s);
  const actionsSkip = useCacheStore((s) => s.actionsSkip);
  const { data, refetch } = useQuery<AllActionsQuery, AllActionsQueryVariables>(ALL_ACTIONS, {
    variables: { installationId: selectedInstallationId },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    skip: skipLavvaFetch || actionsSkip,
  });

  useEffect(() => {
    if (data?.userActions) setActions(data.userActions as UserActionsCollectionSegmentPick, true);
  }, [data?.userActions]);

  const fetchActions = async () => {
    resetRefetchActions();

    try {
      const { data } = await refetch({ installationId: selectedInstallationId });

      if (data?.userActions) setActions(data.userActions as UserActionsCollectionSegmentPick, true);
    } catch (err) {
      console.error('Refetch failed:', err);
    }
  };

  useEffect(() => {
    if (shouldRefetchActions && selectedInstallationId) fetchActions();
  }, [shouldRefetchActions, selectedInstallationId, fetchActions]);
};
